import React, { HTMLAttributes } from 'react';

interface NoEntitiesMessageProps extends HTMLAttributes<HTMLParagraphElement> {}

export const NoEntitiesMessage: React.FC<NoEntitiesMessageProps> = ({
  children,
  ...props
}) => {
  return (
    <p {...props} className={'text-gray-600 text-sm' + ' ' + props.className}>
      {children}
    </p>
  );
};

export default NoEntitiesMessage;
